import React from "react";
import { usePWA } from "../../context/PWAContext";
import { CloudOff, RefreshCw } from "lucide-react";

/**
 * OfflineBadge — discreet pill that appears at the top of the page when the
 * user is offline OR when there are pending offline ops queued for sync.
 */
export default function OfflineBadge() {
  const { online, pendingOps } = usePWA();
  if (online && pendingOps === 0) return null;

  if (!online) {
    return (
      <div
        className="fixed top-3 left-1/2 -translate-x-1/2 z-50 bg-neutral-900 text-white px-3 py-1.5 rounded-full text-xs flex items-center gap-1.5 shadow-lg"
        data-testid="offline-badge"
      >
        <CloudOff size={12} /> Offline · changes will sync
      </div>
    );
  }

  // Online, but queue still has items waiting to drain
  return (
    <div
      className="fixed top-3 left-1/2 -translate-x-1/2 z-50 bg-amber-500 text-white px-3 py-1.5 rounded-full text-xs flex items-center gap-1.5 shadow-lg"
      data-testid="syncing-badge"
    >
      <RefreshCw size={12} className="animate-spin" /> Syncing {pendingOps}…
    </div>
  );
}
